import { PlayCircle, Clock } from "lucide-react";

export default function ModuleIntroPlaceholder({ module }) {
  if (!module?.intro_video_placeholder) return null;

  return (
    <div className="bg-gradient-to-r from-slate-800 to-slate-900 rounded-xl p-6 mb-8 text-white" data-testid="module-intro-video">
      <div className="flex items-center gap-4">
        <div className="w-24 h-24 sm:w-32 sm:h-20 bg-white/10 rounded-lg flex items-center justify-center shrink-0 border border-white/20">
          <PlayCircle className="w-10 h-10 text-white/60" />
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="text-lg font-bold mb-1">Module Overview</h3>
          <p className="text-sm text-white/70">What you'll learn and how it applies in real life</p>
          <div className="flex items-center gap-1.5 mt-2 text-xs text-white/50">
            <Clock className="w-3.5 h-3.5" />
            <span>60-90 seconds</span>
            <span className="mx-1">|</span>
            <span className="bg-white/10 px-2 py-0.5 rounded-full">Coming Soon</span>
          </div>
        </div>
      </div>
    </div>
  );
}
